import axios from "axios";

const BASE_URL =
	import.meta.env.VITE_SERVER_BASE_URL || "http://localhost:3000";

export const api = axios.create({
	baseURL: `${BASE_URL}/partner-api`,
	headers: {
		"Content-Type": "application/json",
	},
});

let authInterceptorId: number | null = null;

export const setAuthInterceptor = (getToken: () => Promise<string | null>) => {
	if (authInterceptorId !== null) {
		api.interceptors.request.eject(authInterceptorId);
	}
	authInterceptorId = api.interceptors.request.use(async (config) => {
		const token = await getToken();
		if (token) {
			config.headers.Authorization = `Bearer ${token}`;
		}
		return config;
	});
};
